import React, { memo } from "react";
import NodeWrapper from "./NodeWrapper";
import { ErrorOutline } from "@mui/icons-material";

/**
 * Error Trigger Node — Executar quando outro flow/node falha.
 *
 * data.watchFlowId: string — ID do flow a monitorar (vazio = todos)
 * data.watchNodeTypes: string[] — tipos de nodes a monitorar (vazio = todos)
 * data.errorVar: string — variavel para receber o objeto de erro
 *
 * Este node funciona como trigger — sem entrada, apenas saida.
 */
const ErrorTriggerNode = memo(({ id, data, isConnectable, selected }) => {
  const watchFlowId = data?.watchFlowId || "";
  const errorVar = data?.errorVar || "error";

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<ErrorOutline />}
      title="Trigger de Erro"
      color="#d32f2f"
      bgColor="#FFCDD2"
      isConnectable={isConnectable}
      selected={selected}
      minWidth={200}
    >
      <div style={{
        background: "#fff", border: "1px solid #e0e0e0",
        borderRadius: 6, padding: "5px 10px", fontSize: 11,
      }}>
        <div style={{ color: "#666", fontSize: 10 }}>
          {watchFlowId ? (
            <>
              <span style={{ color: "#999" }}>Monitorando: </span>
              <span style={{ color: "#d32f2f", fontWeight: 600 }}>Flow #{watchFlowId}</span>
            </>
          ) : (
            <span style={{ color: "#999", fontStyle: "italic" }}>Monitorando todos os flows</span>
          )}
        </div>
        <div style={{ marginTop: 4, color: "#999", fontSize: 10 }}>
          erro → ${"{" + errorVar + "}"}
        </div>
      </div>
    </NodeWrapper>
  );
});

ErrorTriggerNode.displayName = "ErrorTriggerNode";
export default ErrorTriggerNode;
